module.exports = __webpack_public_path__ + "static/media/patek-logo-white.40957ba1.svg";